"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalContentHeaderStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
var _colors_1 = require("../../../../style/commons/_colors");
exports.useModalContentHeaderStyles = (0, styles_1.makeStyles)(function () { return ({
    main: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    title: {
        fontFamily: 'Roboto',
        fontSize: 18,
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: _colors_1.darkSecondary,
    },
    centered: {
        width: '100%',
        textAlign: 'center',
    },
}); });
